import { Api } from "@swegon/sds-core";

class AhuApi extends Api {
    constructor(url, config) {
        super(url, config);
        this.type = "REST";
    }

    getVersion() {
        return this.get(`${this.originalUrl}version/version`, true);
    }
}

export default AhuApi;
